// Gestão de sessão — o JWT fica em cookie httpOnly (Secure, SameSite=Strict)
// emitido pelo back; nenhum script da página lê o token. O localStorage guarda
// só dados não sensíveis de UI (nome, perfil, permissões, tela inicial) e o
// instante de expiração, para validar a sessão sem esperar o 401 do servidor.
// Autorização por permissões do perfil (RBAC): o back envia permissoes[] e
// telaInicial no login/renovação; o front só esconde telas (enforcement real é o back).

const EXPIRA_EM_KEY = 'patio_expira_em';
const NOME_KEY = 'patio_nome';
const PERFIL_KEY = 'patio_perfil';
const PERMISSOES_KEY = 'patio_permissoes';
const TELA_INICIAL_KEY = 'patio_tela_inicial';
const SENHA_TEMP_KEY = 'patio_senha_temporaria';

// Sessão de versão anterior do front (JWT em localStorage): o cookie ainda não
// existe, então a sessão antiga é descartada e o usuário refaz o login.
const TOKEN_KEY_LEGADO = 'patio_token';

export const setSession = ({ expiraEm, nomeCompleto, perfil, permissoes, telaInicial, senhaTemporaria }) => {
    localStorage.removeItem(TOKEN_KEY_LEGADO);
    if (expiraEm) localStorage.setItem(EXPIRA_EM_KEY, String(expiraEm));
    localStorage.setItem(NOME_KEY, nomeCompleto || '');
    localStorage.setItem(PERFIL_KEY, perfil || '');
    localStorage.setItem(PERMISSOES_KEY, JSON.stringify(permissoes || []));
    localStorage.setItem(TELA_INICIAL_KEY, telaInicial || '/dashboard');
    localStorage.setItem(SENHA_TEMP_KEY, senhaTemporaria ? '1' : '');
};

export const getExpiraEm = () => Number(localStorage.getItem(EXPIRA_EM_KEY)) || 0;

// Só a validade: usado quando o back reemite o token sem mudar perfil nem
// permissões (troca de senha), para não zerar o resto da sessão.
export const atualizarExpiracao = (expiraEm) => {
    if (expiraEm) localStorage.setItem(EXPIRA_EM_KEY, String(expiraEm));
};

export const removeSession = () => {
    localStorage.removeItem(EXPIRA_EM_KEY);
    localStorage.removeItem(TOKEN_KEY_LEGADO);
    localStorage.removeItem(NOME_KEY);
    localStorage.removeItem(PERFIL_KEY);
    localStorage.removeItem(PERMISSOES_KEY);
    localStorage.removeItem(TELA_INICIAL_KEY);
    localStorage.removeItem(SENHA_TEMP_KEY);
};

export const isSenhaTemporaria = () => localStorage.getItem(SENHA_TEMP_KEY) === '1';
export const limparSenhaTemporaria = () => localStorage.setItem(SENHA_TEMP_KEY, '');

export const isTokenValid = () => {
    const expiraEm = getExpiraEm();
    return expiraEm > 0 && expiraEm > Date.now();
};

export const isAuthenticated = () => isTokenValid();

export const getNomeCompleto = () => localStorage.getItem(NOME_KEY) || '';
export const getPerfil = () => localStorage.getItem(PERFIL_KEY) || '';
export const getTelaInicial = () => localStorage.getItem(TELA_INICIAL_KEY) || '/dashboard';

export const getPermissoes = () => {
    try {
        return JSON.parse(localStorage.getItem(PERMISSOES_KEY)) || [];
    } catch {
        return [];
    }
};

export const temPermissao = (permissao) => getPermissoes().includes(permissao);

// Sessão de versão anterior do front (sem permissões no storage): precisa
// re-hidratar via GET /api/auth/me — ver hidratarSessaoSeNecessario em api.js
export const sessaoSemPermissoes = () => isAuthenticated() && localStorage.getItem(PERMISSOES_KEY) === null;
